var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 413 413",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(1,0,0,1.01369,-52.1731,-40.4187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.173,
    y: 39.873,
    width: 412.688,
    height: 407.127,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.173,
    y: 39.873,
    width: 412.688,
    height: 407.127
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.986496,0.173086,4.14841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.2,433.8C289.6,426.5 269.6,404.1 251.6,384L219,347.5L219,322.2C219,308.2 219.3,297 219.8,297.2C220.2,297.4 223.9,299.2 228,301.2C239.2,306.6 246.7,308.4 259.5,308.4C272.3,308.4 280.2,306.6 290,301.4C327.5,281.7 338.7,233.3 313.5,200.3C304.4,188.4 288.9,178.2 275,174.9C267.2,173 250.9,173.3 243,175.3C223.8,180.4 207.9,193.2 198.6,211C191.2,225.1 191.7,217.5 191.1,335.7L190.5,441.8L182.4,438.5C171.7,434.2 151.7,423.8 145.7,419.4L140.9,415.9L141.3,320.7C141.6,228.6 141.7,225.2 143.7,216.5C146.4,204.8 149.4,196.3 154,187C168.7,157.8 196.9,134.9 228.7,126.3C237.8,123.8 239.9,123.6 259.5,123.6C279.2,123.6 281.1,123.8 290.5,126.3C317.2,133.5 342.6,152.1 358.6,176C373.4,198.4 380,225.3 377.2,252.8C374.2,282.4 363.2,305.1 341.7,326.2C329.7,337.9 318.6,344.9 298.4,353.6C296.4,354.4 299.1,357.6 328.1,389.9C345.7,409.3 360,425.5 360,425.9C360,427.9 334.9,439.1 319.4,443.9C314,445.6 309.2,447 308.8,447C308.4,447 302.7,441 296.2,433.8Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.7,389.4L353,370.8L356.8,367.8C358.8,366.2 364.5,361 369.3,356.2C391.7,334.2 405.6,308.3 412.6,276C415.2,264 415.3,229.3 412.7,217C400.8,160.3 361.6,116.2 307.3,98.4C276.6,88.4 240.4,88.4 209.6,98.4C154.1,116.6 113.8,163.3 104,220.7C100.4,241.8 101.8,268.7 107.6,288.6C110,297 110,297.1 110,343.7L110,390.4L105.5,385.5C76.9,354 59.1,315.1 53.4,271.9C51.4,256.7 51.9,226.3 54.5,212.5C66.7,145.4 106.9,91.1 166.6,61.2C202.4,43.3 245,36.3 286.2,41.6C371.4,52.6 442.3,117.9 460.4,202C464.3,220 465.3,232.3 464.7,252.9C463.3,302 446.7,344.4 414,382.6C407,390.8 388.7,408 387.1,408C386.7,408 378.8,399.6 369.7,389.4Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42847409.svg";
export { ForwardRef as ReactComponent };